import _classCallCheck from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * DevExtreme (esm/ui/tab_panel/item.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import CollectionWidgetItem from "../collection/item";
import { noop } from "../../core/utils/common";
var TabPanelItem = /*#__PURE__*/function (_CollectionWidgetItem) {
  _inherits(TabPanelItem, _CollectionWidgetItem);
  function TabPanelItem() {
    _classCallCheck(this, TabPanelItem);
    return _possibleConstructorReturn(this, _getPrototypeOf(TabPanelItem).apply(this, arguments));
  }
  _createClass(TabPanelItem, [{
    key: "_renderWatchers",
    value: function _renderWatchers() {
      this._startWatcher("badge", noop);
      return _get(_getPrototypeOf(TabPanelItem.prototype), "_renderWatchers", this).call(this);
    }
  }]);
  return TabPanelItem;
}(CollectionWidgetItem);
export { TabPanelItem as default };